module.exports = __webpack_public_path__ + "img/48.fdb1876b.jpg";